import React, { useContext, useEffect, useState } from "react";
import { Title } from "../../../../../../stories/Title/Title";

import { FormControlLabel, Step, StepLabel, Stepper } from "@mui/material";
import { LicenseTypes, Operation } from "../../../../../../utils/Enum.types";
import { Button } from "../../../../../../stories/Button/Button";
import { Label } from "../../../../../../stories/Label/Label";
import TextArea from "../../../../../../stories/TextArea/TextArea";

import {
  addCountryCode,
  handleFormEvent,
  handleMUISelectEvent,
  hanldeTextAreaFormEvent,
  removeMoreSpace,
} from "../../../../../../utils/UtilFunctions";
import { AntSwitch } from "../../../../../../styles/Switch";
import { useNavigate } from "react-router-dom";
import Close from "../../../../../../images/Close.svg";
import {
  CompanyFormData,
  PredefinedDataTypes,
} from "../../../../../../utils/formTypes";

import useUrlParams from "../../../../../../customHooks/useUrlParams";
import useLoggedInUserDetails from "../../../../../../customHooks/useLoggedInUserDetails";
import {
  EMPTY_STRING,
  emptyMessage,
  ROWS_PER_PAGE,
} from "../../../../../../utils/constants";
import { AppContext } from "../../../../../../context/context";
import { LabelProps } from "../../../../../../utils/types";
import { Form, Formik, FormikProps } from "formik";
import { companyValidation } from "../../../../../../utils/validationSchema";
import InputNumber from "../../../../../common/Input/InputNumber";
import PredefinedAutocomplete from "../../../../../../customComponents/PredefinedAutocmplete";
import InputHoc from "../../../../../common/Input/Index";
import { useLazyQuery, useMutation } from "@apollo/client";
import { AddSubsidiary, UpdateSubsidiary } from "../queries/mutations";
import {
  AddSubsidiaryResult,
  AddSubsidiaryVar,
  AtsSubsidiary,
  AtsSubsidiaryOrderField,
  UpdateSubsidiaryResult,
  UpdateSubsidiaryVar,
} from "../queries/types";
import { GetSubsidiaries, GetSubsidiaryNodeById } from "../queries/queries";
import {
  nodeVar,
  OrderDirection,
} from "../../../../../../utils/commonQueryTypes";
import MessageModal from "../../../../../../customComponents/MessageModal";
import { Keys } from "../../../../../../utils/Enum.keys";
import { payloadTypes } from "../../../../../../context/reducer";
import PhoneInput from "react-phone-input-2";
import LoadingModal from "../../../../../pages/LoadingModal";
import StatesAutocomplete from "../../../../../../customComponents/States";
import GstInputComponent from "../../../../../common/Input/GstInputComponent";
import Navbar from "../../../../../common/layout/Navbar";
import PredefinedSelect from "../../../../../../customComponents/PredefinedSelect";
import useLabels from "../../../../../../customHooks/useLabels";
import useFormJson from "../../../../../../json/useFormJson";
import IconSelect from "../../../../../../customComponents/IconSelect";

export const subsidaryStepHeader = () => {
  return [
    "Subsidiary Details",
    "Asset Site or Location Points",

    // "User Details"
  ];
};

export interface subsidaryCreateProps {
  operation: Operation;
  setModalFlag: React.Dispatch<React.SetStateAction<boolean>>;
}

const SubsidiaryAdd = ({ operation, setModalFlag }: subsidaryCreateProps) => {
  const { companyLabel, itemLabel, subsidiaryLabel } = useLabels();
  const subsidaryStepHeader = () => {
    return [
      `${subsidiaryLabel} Details`,
      `${itemLabel} Site or Location Points`,

      // "User Details"
    ];
  };
  const stepsHeader = subsidaryStepHeader();
  const navigate = useNavigate();
  
  const { companyFormLabels } = useFormJson();
  const { customer_id, company_id } = useUrlParams();

  const { user_details } = useLoggedInUserDetails();
  const [message, setMessage] = useState(emptyMessage);

  const { dispatch } = useContext(AppContext);
  const { state } = useContext(AppContext);
  const [GetSubById, { loading: GetSubsidiaryNodeByIdLoading }] = useLazyQuery<
    { node: AtsSubsidiary },
    nodeVar
  >(GetSubsidiaryNodeById);
  const [AddSubDetails, { loading: AddSubsidiaryLoading }] = useMutation<
    AddSubsidiaryResult,
    AddSubsidiaryVar
  >(AddSubsidiary, {
    onError: (e) => {
      setMessage({
        flag: true,
        message: e.message,
        operation: Operation.NONE,
      });
    },
  });

  const [UpdateSubDetails, { loading: UpdateSubsidiaryLoading }] = useMutation<
    UpdateSubsidiaryResult,
    UpdateSubsidiaryVar
  >(UpdateSubsidiary, {
    onError: (e) => {
      setMessage({
        flag: true,
        message: e.message,
        operation: Operation.NONE,
      });
    },
  });

  const initialValues: CompanyFormData = {
    // Company Details
    name: "", // Default: empty string for company name
    address: "", // Default: empty string for address
    pin: "", // Default: empty string for pin code
    telephone: "", // Default: empty string for telephone
    email: "", // Default: empty string for email
    mobile: "", // Default: empty string for mobile number
    place: "", // Default: empty string for place
    country: "", // Default: "India" for country
    state: "", // Default: empty string for state

    // Contact Details
    contactPerson: "", // Default: empty string for contact person name
    contactPersonDesign: "", // Default: empty string for contact person designation
    contactPersonEmail: "", // Default: empty string for contact person email
    contactPersonMobile: "", // Default: empty string for contact person mobile number
    url: "", // Default: empty string for company URL

    // Statuary Details
    enableGst: false, // Default: false for enable GST
    gstNo: "", // Default: empty string for GSTIN number
    tanNo: "", // Default: empty string for TAN registration number
    panNo: "", // Default: empty string for PAN registration number
    enableTds: false, // Default: false for enable TDS
    enableTcs: false, // Default: false for enable TCS
    vatNo: "",
    regType: "", // Default: empty string for registration type
    gstState: "", // Default: empty string for GST state
    latitude: "",
    longitude: "",
    gstStateCode: "",
    icon: "",
  };

  const [formData, setFormData] = useState<CompanyFormData>(initialValues);

  const handleValueChange = (
    e: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>,
    meta: FormikProps<CompanyFormData>
  ) => {
    const { name, value } = e.target as HTMLInputElement;

    let finalValue = "";
    if (e.target.name === "gstNo") {
      finalValue = value.toLocaleUpperCase();
    } else {
      finalValue = value;
    }
    setFormData(() => ({
      ...formData,
      [name]: finalValue,
    }));
    meta.handleChange(e);
  };

  const handleChecked = (
    e: React.ChangeEvent<HTMLInputElement>,
    meta: FormikProps<CompanyFormData>
  ) => {
    const { name, checked } = e.target as HTMLInputElement;

    setFormData(() => ({
      ...formData,
      [name]: checked,
    }));
    meta.handleChange(e);
  };

  const handleSubmit = async () => {
    if (customer_id && company_id) {
      if (operation === Operation.CREATE) {
        const empAdded = AddSubDetails({
          variables: {
            
            user_details,
            customerID: customer_id,
            companyID: company_id,
            input: {
              name: removeMoreSpace(formData.name),
              address: removeMoreSpace(formData.address),
              place: removeMoreSpace(formData.place),
              email: formData.email,
              mobile: addCountryCode(formData.mobile),
              pin: formData.pin,
              state: formData.state,
              contactPerson: removeMoreSpace(formData.contactPerson),
              contactPersonDesign: formData.contactPersonDesign,
              contactPersonEmail: formData.contactPersonEmail,
              contactPersonMobile: addCountryCode(
                formData.contactPersonMobile
              ),
              country: formData.country,
              gstNo: (formData.gstStateCode + formData.gstNo) as string,
              latitude: Number(formData.latitude),
              longitude: Number(formData.longitude),
              logoFilename: "",
              panNo: formData.panNo,
              tanNo: formData.tanNo,
              url: formData.url,
              vatNo: "",
              oth1No: "",
              oth2No: "",
              enableGst: formData.enableGst,
              enableTcs: formData.enableTcs,
              enableTds: formData.enableTds,
              icon: formData.icon,
            },
          },
          refetchQueries: [
            {
              query: GetSubsidiaries,
              variables: {
                after: null,
                customerID: customer_id,
                companyID: company_id,
                empID: user_details.id,
                first: ROWS_PER_PAGE,
                orderBy: {
                  direction: OrderDirection.ASC,
                  field: AtsSubsidiaryOrderField.NAME,
                },
                
                name: EMPTY_STRING,
              },
            },
          ],
        });
        const { data } = await empAdded;

        if (data && data.AddSubsidiary && data.AddSubsidiary.id) {
          dispatch({
            type: payloadTypes.SET_SUB_ID,
            payload: {
              subsidiaryId: data.AddSubsidiary.id,
            },
          });
          setMessage({
            flag: true,
            message: `${companyLabel} added successfully`,
            operation: Operation.CREATE,
          });
        }
      } else {
        const customerUpdated = UpdateSubDetails({
          variables: {
            
            user_details,
            subsidiaryID: state.subsidiaryId,
            input: {
              name: removeMoreSpace(formData.name),
              address: removeMoreSpace(formData.address),
              place: removeMoreSpace(formData.place),
              email: formData.email,
              mobile: addCountryCode(formData.mobile),
              pin: formData.pin,
              state: formData.state,
              contactPerson: removeMoreSpace(formData.contactPerson),
              contactPersonDesign: formData.contactPersonDesign,
              contactPersonEmail: formData.contactPersonEmail,
              contactPersonMobile: addCountryCode(
                formData.contactPersonMobile
              ),
              country: formData.country,
              gstNo: formData.gstStateCode + formData.gstNo,
              latitude: Number(formData.latitude),
              longitude: Number(formData.longitude),
              logoFilename: "",
              panNo: formData.panNo,
              tanNo: formData.tanNo,
              url: formData.url,
              vatNo: "",
              oth1No: "",
              oth2No: "",
              enableGst: formData.enableGst,
              enableTcs: formData.enableTcs,
              enableTds: formData.enableTds,
              icon: formData.icon,
            },
          },
          refetchQueries: [
            {
              query: GetSubsidiaries,
              variables: {
                after: null,
                customerID: customer_id,
                companyID: company_id,
                empID: user_details.id,
                first: ROWS_PER_PAGE,
                orderBy: {
                  direction: OrderDirection.ASC,
                  field: AtsSubsidiaryOrderField.NAME,
                },
                
                name: EMPTY_STRING,
              },
            },
          ],
        });
        const { data } = await customerUpdated;

        if (data && data.UpdateSubsidiary) {
          setMessage({
            flag: true,
            message: `${companyLabel} details updated successfully`,
            operation: Operation.UPDATE,
          });
        }
      }
    } else {
      setMessage({
        flag: true,
        message: "Customer not found",
        operation: Operation.CREATE,
      });
    }
  };
  useEffect(() => {
    if (state.subsidiaryId && operation === Operation.UPDATE) {
      GetSubById({
        variables: {
          id: state.subsidiaryId,
          
        },
      }).then(({ data }) => {
        if (data && data.node) {
          const gstStateCode = data.node.gstNo.slice(0, 2);
          const gst = data.node.gstNo.slice(2, data.node.gstNo.length);

          setFormData({
            name: removeMoreSpace(data.node.name),
            address: removeMoreSpace(data.node.address),
            place: removeMoreSpace(data.node.place),
            email: data.node.email,
            mobile: addCountryCode(data.node.mobile),
            pin: data.node.pin,
            state: data.node.state,
            contactPerson: removeMoreSpace(data.node.contactPerson),
            contactPersonDesign: data.node.contactPersonDesign,
            contactPersonEmail: data.node.contactPersonEmail,
            contactPersonMobile: addCountryCode(
              data.node.contactPersonMobile
            ),
            country: data.node.country,
            gstNo: gst,
            latitude: data.node.latitude.toString(),
            longitude: data.node.longitude.toString(),
            logoFilename: "",
            panNo: data.node.panNo,
            tanNo: data.node.tanNo,
            url: data.node.url,
            vatNo: "",
            oth1No: "",
            enableGst: data.node.enableGst,
            enableTcs: data.node.enableTcs,
            enableTds: data.node.enableTds,
            gstState: data.node.gstState,
            mobileNo: data.node.mobileNo,
            regType: data.node.regType,
            telephone: data.node.telephone,
            gstStateCode,
            icon: data.node.icon,
          });
        }
      });
    }
  }, [state.subsidiaryId, GetSubById, operation]);

  const hanldeClear = () => {
    const inputElement = document.getElementsByName(
      "name"
    )[0] as HTMLInputElement;
    if (inputElement) inputElement.focus();

    setFormData(initialValues);
  };

  const handleClose = () => {
    setMessage(emptyMessage);
    if (message.operation !== Operation.NONE) {
      hanldeClear();
      setModalFlag(false);
    }
  };

  const handleNumberChange = (name: string, value: string) => {
    setFormData((prevValues) => ({
      ...prevValues,
      [name]: value,
    }));
  };

  return (
    <>
      <div className={`subsidary__add--edit`}>
        <Formik
          initialValues={formData}
          validationSchema={companyValidation}
          onSubmit={handleSubmit}
          enableReinitialize
          validateOnChange
        >
          {(meta) => {
            return (
              <Form className={`subsidary__add--form--edit`}>
                <div className="subsidary__add--title">
                  {operation === Operation.CREATE ? (
                    <Title>Add {subsidiaryLabel} Details</Title>
                  ) : (
                    <Title>Edit {subsidiaryLabel} Details</Title>
                  )}
                  <img src={Close} alt="" onClick={() => setModalFlag(false)} />
                </div>

                <div className="subsidary__add--form-details">
                  <div className="company-details__block--left">
                    <div className="company-details__block--details">
                      <h4>{subsidiaryLabel} Details</h4>
                    </div>
                    {companyFormLabels.companyDetails.map(
                      (field: LabelProps, key: React.Key) => {
                        if (field.dataType === "mobile") {
                          return (
                            <div className="label-grid" key={key}>
                              <Label>{field.labelName}</Label>
                              <PhoneInput
                                country={"in"}
                                value={formData[field.inputName] as string}
                                onChange={(e: string) => {
                                  handleNumberChange(field.inputName, e);
                                }}
                                onKeyDown={(e) => {
                                  if (e.key === Keys.ENTER) {
                                    e.preventDefault();
                                    handleMUISelectEvent(e);
                                  }
                                }}
                              />
                              {meta.touched[field.inputName] &&
                              meta.errors[field.inputName] ? (
                                <div className="label-grid">
                                  <span />
                                  <span className="nodata">
                                    {meta.errors[field.inputName]}
                                  </span>
                                </div>
                              ) : null}
                            </div>
                          );
                        } else if (field.dataType === "textarea") {
                          return (
                            <React.Fragment key={key}>
                              <div className="label-grid">
                                <Label>{field.labelName}</Label>
                                <TextArea
                                  value={formData[field.inputName]}
                                  onChange={(
                                    e: React.ChangeEvent<HTMLTextAreaElement>
                                  ) => {
                                    handleValueChange(e, meta);
                                  }}
                                  type={field.dataType}
                                  rows={3}
                                  name={field.inputName}
                                  required={field.required}
                                  onKeyDown={(e) => {
                                    hanldeTextAreaFormEvent(
                                      e,
                                      setFormData as React.Dispatch<
                                        React.SetStateAction<{
                                          [key: string]: string | number;
                                        }>
                                      >
                                    );
                                  }}
                                />
                              </div>
                              {meta.touched[field.inputName] &&
                              meta.errors[field.inputName] ? (
                                <div className="label-grid">
                                  <span />
                                  <span className="nodata">
                                    {meta.errors[field.inputName]}
                                  </span>
                                </div>
                              ) : null}
                            </React.Fragment>
                          );
                        } else if (field.dataType === "number") {
                          return (
                            <React.Fragment key={key}>
                              <div className="label-grid">
                                <Label>{field.labelName}</Label>
                                <InputNumber
                                  value={formData[field.inputName]}
                                  onChange={(
                                    e: React.ChangeEvent<HTMLInputElement>
                                  ) => {
                                    handleValueChange(e, meta);
                                  }}
                                  name={field.inputName}
                                  required={field.required}
                                  maxLength={field.maxLength}
                                  onKeyDown={handleFormEvent}
                                />
                              </div>
                              {meta.touched[field.inputName] &&
                              meta.errors[field.inputName] ? (
                                <div className="label-grid">
                                  <span />
                                  <span className="nodata">
                                    {meta.errors[field.inputName]}
                                  </span>
                                </div>
                              ) : null}
                            </React.Fragment>
                          );
                        } else if (field.dataType === "city") {
                          return (
                            <div className="label-grid">
                              <Label>{field.labelName}</Label>
                              <PredefinedSelect
                                label=""
                                onChange={(e) => {
                                  setFormData({
                                    ...formData,
                                    place: e,
                                  });
                                }}
                                type={PredefinedDataTypes.CITY}
                                value={formData.place as string}
                                name={field.inputName as string}
                              />
                            </div>
                          );
                        } else if (field.dataType === "state") {
                          return (
                            <div className="label-grid">
                              <Label>{field.labelName}</Label>
                              <PredefinedSelect
                                label=""
                                onChange={(e, state_code) => {
                                  setFormData({
                                    ...formData,
                                    state: e,
                                    gstStateCode: state_code
                                      ? state_code
                                      : EMPTY_STRING,
                                  });
                                }}
                                type={PredefinedDataTypes.STATE}
                                value={formData.state as string}
                                name={field.inputName as string}
                              />
                            </div>
                          );
                        } else if (field.dataType === "country") {
                          return (
                            <div className="label-grid">
                              <Label>{field.labelName}</Label>
                              <PredefinedSelect
                                label=""
                                onChange={(e) => {
                                  setFormData({
                                    ...formData,
                                    country: e,
                                  });
                                }}
                                type={PredefinedDataTypes.COUNTRY}
                                value={formData.country as string}
                                name={field.inputName as string}
                              />
                            </div>
                          );
                        } else {
                          return (
                            <React.Fragment key={key}>
                              <InputHoc
                                LabelName={field.labelName}
                                values={formData[field.inputName]}
                                name={field.inputName}
                                onChange={(
                                  e: React.ChangeEvent<HTMLInputElement>
                                ) => {
                                  handleValueChange(e, meta);
                                }}
                                required={field.required}
                                autoFocus={field.autoFocus}
                                onKeyDown={handleFormEvent}
                              />
                              {meta.touched[field.inputName] &&
                              meta.errors[field.inputName] ? (
                                <div className="label-grid">
                                  <span />
                                  <span className="nodata">
                                    {meta.errors[field.inputName]}
                                  </span>
                                </div>
                              ) : null}
                            </React.Fragment>
                          );
                        }
                      }
                    )}
                    <div className="company-details__block--details">
                      <h4>Contact Details</h4>
                    </div>
                    {companyFormLabels.contactDetails.map(
                      (field: LabelProps, key: React.Key) => {
                        if (field.dataType === "mobile") {
                          return (
                            <div className="label-grid" key={key}>
                              <Label>{field.labelName}</Label>

                              <PhoneInput
                                country={"in"}
                                value={formData[field.inputName] as string}
                                onChange={(e: string) => {
                                  handleNumberChange(field.inputName, e);
                                }}
                                onKeyDown={(e) => {
                                  if (e.key === Keys.ENTER) {
                                    e.preventDefault();
                                    handleMUISelectEvent(e);
                                  }
                                }}
                              />
                              {meta.touched[field.inputName] &&
                              meta.errors[field.inputName] ? (
                                <div className="label-grid">
                                  <span />
                                  <span className="nodata">
                                    {meta.errors[field.inputName]}
                                  </span>
                                </div>
                              ) : null}
                            </div>
                          );
                        } else if (field.dataType === "number") {
                          return (
                            <React.Fragment key={key}>
                              <div className="label-grid">
                                <Label>{field.labelName}</Label>
                                <InputNumber
                                  value={formData[field.inputName]}
                                  onChange={(
                                    e: React.ChangeEvent<HTMLInputElement>
                                  ) => {
                                    handleValueChange(e, meta);
                                  }}
                                  name={field.inputName}
                                  required={field.required}
                                  maxLength={field.maxLength}
                                  onKeyDown={handleFormEvent}
                                />
                              </div>
                              {meta.touched[field.inputName] &&
                              meta.errors[field.inputName] ? (
                                <div className="label-grid">
                                  <span />
                                  <span className="nodata">
                                    {meta.errors[field.inputName]}
                                  </span>
                                </div>
                              ) : null}
                            </React.Fragment>
                          );
                        } else if (field.dataType === "city") {
                          return (
                            <div className="label-grid">
                              <Label>{field.labelName}</Label>
                              <PredefinedSelect
                                label=""
                                onChange={(e) => {
                                  setFormData({
                                    ...formData,
                                    place: e,
                                  });
                                }}
                                type={PredefinedDataTypes.CITY}
                                value={formData.place as string}
                                name={field.inputName as string}
                              />
                            </div>
                          );
                        } else if (field.dataType === "state") {
                          return (
                            <div className="label-grid">
                              <Label>{field.labelName}</Label>
                              <PredefinedSelect
                                label=""
                                onChange={(e, state_code) => {
                                  setFormData({
                                    ...formData,
                                    state: e,
                                    gstStateCode: state_code
                                      ? state_code
                                      : EMPTY_STRING,
                                  });
                                }}
                                type={PredefinedDataTypes.STATE}
                                value={formData.state as string}
                                name={field.inputName as string}
                              />
                            </div>
                          );
                        } else if (field.dataType === "country") {
                          return (
                            <div className="label-grid">
                              <Label>{field.labelName}</Label>
                              <PredefinedSelect
                                label=""
                                onChange={(e) => {
                                  setFormData({
                                    ...formData,
                                    country: e,
                                  });
                                }}
                                type={PredefinedDataTypes.COUNTRY}
                                value={formData.country as string}
                                name={field.inputName as string}
                              />
                            </div>
                          );
                        } else {
                          return (
                            <React.Fragment key={key}>
                              <InputHoc
                                LabelName={field.labelName}
                                values={formData[field.inputName]}
                                name={field.inputName}
                                onChange={(
                                  e: React.ChangeEvent<HTMLInputElement>
                                ) => {
                                  handleValueChange(e, meta);
                                }}
                                required={field.required}
                                onKeyDown={handleFormEvent}
                              />
                              {meta.touched[field.inputName] &&
                              meta.errors[field.inputName] ? (
                                <div className="label-grid">
                                  <span />
                                  <span className="nodata">
                                    {meta.errors[field.inputName]}
                                  </span>
                                </div>
                              ) : null}
                            </React.Fragment>
                          );
                        }
                      }
                    )}
                  </div>
                  <div className="company-details__block--right">
                    <div className="company-details__block--details">
                      <h4>Satutory Details</h4>
                    </div>
                    {companyFormLabels.statuaryDetails.map(
                      (field: LabelProps, key: React.Key) => {
                        if (field.inputName === "enableGst") {
                          return (
                            <div
                              className={`company-details__block--right--gst${
                                !formData.enableGst ? "" : "--wb"
                              }`}
                            >
                              <FormControlLabel
                                label="Enable GST"
                                labelPlacement="start"
                                name={field.inputName}
                                control={
                                  <AntSwitch
                                    checked={formData[field.inputName]}
                                    // onClick={() => {
                                    //   setGst(!gst);
                                    // }}
                                    onKeyDown={handleFormEvent}
                                    onChange={(e) => {
                                      handleChecked(e, meta);
                                    }}
                                  />
                                }
                                className="company-details__block--right--gst--form-labels"
                              />
                              {formData.enableGst && (
                                <>
                                  <div className="company-details__block--subdetails">
                                    <h4>GST Details</h4>
                                  </div>
                                  {field.formFields
                                    ? field.formFields.map((sub_field) => {
                                        if (sub_field.dataType === "state") {
                                          return (
                                            <div className="label-grid">
                                              <Label>
                                                {sub_field.labelName}
                                              </Label>
                                              <PredefinedSelect
                                                label=""
                                                onChange={(e, state_code) => {
                                                  setFormData({
                                                    ...formData,
                                                    gstState: e,
                                                    gstStateCode: state_code
                                                      ? state_code
                                                      : EMPTY_STRING,
                                                  });
                                                }}
                                                type={PredefinedDataTypes.STATE}
                                                value={
                                                  formData.gstState as string
                                                }
                                                name={field.inputName as string}
                                              />
                                            </div>
                                          );
                                        } else if (
                                          sub_field.dataType === "regType"
                                        ) {
                                          return (
                                            <div className="label-grid">
                                              <Label>
                                                {sub_field.labelName}
                                              </Label>
                                              <PredefinedAutocomplete
                                                label=""
                                                onChange={(newValue) => {
                                                  if (newValue) {
                                                    setFormData({
                                                      ...formData,
                                                      [sub_field.inputName]:
                                                        newValue.value,
                                                    });
                                                  } else {
                                                    setFormData({
                                                      ...formData,
                                                      [sub_field.inputName]: "",
                                                    });
                                                  }
                                                }}
                                                type={
                                                  PredefinedDataTypes.GST_REGISTRATION_TYPE
                                                }
                                                value={
                                                  formData[
                                                    sub_field.inputName
                                                  ] as string
                                                }
                                                edit={
                                                  operation === Operation.UPDATE
                                                    ? true
                                                    : false
                                                }
                                              />
                                            </div>
                                          );
                                        } else if (
                                          sub_field.dataType === "gstNo"
                                        ) {
                                          return (
                                            <div className="label-grid">
                                              <Label>
                                                {sub_field.labelName}
                                              </Label>
                                              <GstInputComponent
                                                state_code={
                                                  formData.gstStateCode
                                                }
                                                values={
                                                  formData[
                                                    sub_field.inputName
                                                  ] as string
                                                }
                                                name={sub_field.inputName}
                                                onChange={(
                                                  e: React.ChangeEvent<HTMLInputElement>
                                                ) => {
                                                  handleValueChange(e, meta);
                                                }}
                                                required={sub_field.required}
                                                max={
                                                  sub_field.maxLength
                                                    ? sub_field.maxLength
                                                    : 20
                                                }
                                              />
                                              {meta.touched &&
                                              meta.errors[
                                                sub_field.inputName
                                              ] ? (
                                                <span className="nodata">
                                                  {
                                                    meta.errors[
                                                      sub_field.inputName
                                                    ]
                                                  }
                                                </span>
                                              ) : null}
                                            </div>
                                          );
                                        } else {
                                          return (
                                            <React.Fragment key={key}>
                                              <InputHoc
                                                LabelName={sub_field.labelName}
                                                values={
                                                  formData[sub_field.inputName]
                                                }
                                                name={sub_field.inputName}
                                                onChange={(
                                                  e: React.ChangeEvent<HTMLInputElement>
                                                ) => {
                                                  handleValueChange(e, meta);
                                                }}
                                                onKeyDown={handleFormEvent}
                                              />
                                              {meta.touched &&
                                              meta.errors[
                                                sub_field.inputName
                                              ] ? (
                                                <div className="label-grid">
                                                  <span />
                                                  <span className="nodata">
                                                    {
                                                      meta.errors[
                                                        sub_field.inputName
                                                      ]
                                                    }
                                                  </span>
                                                </div>
                                              ) : null}
                                            </React.Fragment>
                                          );
                                        }
                                      })
                                    : null}
                                </>
                              )}
                            </div>
                          );
                        } else if (field.dataType === "text") {
                          return (
                            <React.Fragment key={key}>
                              <InputHoc
                                LabelName={field.labelName}
                                values={formData[field.inputName]}
                                name={field.inputName}
                                onChange={(
                                  e: React.ChangeEvent<HTMLInputElement>
                                ) => {
                                  handleValueChange(e, meta);
                                }}
                                required={field.required}
                                onKeyDown={handleFormEvent}
                              />
                              {meta.touched[field.inputName] &&
                              meta.errors[field.inputName] ? (
                                <div className="label-grid">
                                  <span />
                                  <span className="nodata">
                                    {meta.errors[field.inputName]}
                                  </span>
                                </div>
                              ) : null}
                            </React.Fragment>
                          );
                        } else if (field.inputName === "icon") {
                          return (
                            <IconSelect
                              onChange={(newValue) => {
                                if (newValue) {
                                  setFormData({
                                    ...formData,
                                    icon: newValue.value as unknown as string,
                                  });
                                } else {
                                  setFormData({
                                    ...formData,
                                    icon: "",
                                  });
                                }
                              }}
                            />
                          );
                        } else {
                          return (
                            <>
                              <FormControlLabel
                                label={field.labelName}
                                labelPlacement="start"
                                name={field.inputName}
                                key={key}
                                control={
                                  <AntSwitch
                                    onKeyDown={handleFormEvent}
                                    checked={
                                      formData[field.inputName] as boolean
                                    }
                                    onChange={(e) => {
                                      handleChecked(e, meta);
                                    }}
                                  />
                                }
                                className="company-details__block--right--gst--form-labels"
                              />
                              {meta.touched[field.inputName] &&
                              meta.errors[field.inputName] ? (
                                <div className="label-grid">
                                  <span />
                                  <span className="nodata">
                                    {meta.errors[field.inputName]}
                                  </span>
                                </div>
                              ) : null}
                            </>
                          );
                        }
                      }
                    )}
                  </div>
                </div>

                <Button mode="save" type="submit" />
                <Button mode="clear" onClick={hanldeClear} type="button" />
                <Button
                  mode="cancel"
                  type="button"
                  onClick={() => setModalFlag(false)}
                />
                <MessageModal
                  handleClose={handleClose}
                  modalFlag={message.flag}
                  operation={message.operation}
                  value={message.message}
                />
              </Form>
            );
          }}
        </Formik>
        <LoadingModal
          flag={
            GetSubsidiaryNodeByIdLoading ||
            AddSubsidiaryLoading ||
            UpdateSubsidiaryLoading
          }
        />
      </div>
    </>
  );
};

export default SubsidiaryAdd;
